export default {
    accessToken : null,
    refreshToken : null,
    idToken : null,
    userInfo: {},
    userStatus : null,
    error: false,
    reSendCurrentTime: 60,
    timerInterval: null
}
